import React from "react";
var __jsx = React.createElement;
import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { choicesToOptions } from "@/utils/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Tab-style single select backed by Mantine SegmentedControl. */
export function SingleSelectTabField(_ref) {
  var _field$observation;
  var field = _ref.field,
    value = _ref.value,
    disabled = _ref.disabled,
    _onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var options = choicesToOptions(field.choices, t);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-base text-sds-base-default"
  }, t((_field$observation = field.observation) !== null && _field$observation !== void 0 ? _field$observation : "")), options.length ? /*#__PURE__*/React.createElement(SegmentedControl, {
    fullWidth: true,
    disabled: disabled,
    data: options,
    value: String(value !== null && value !== void 0 ? value : ""),
    onChange: function onChange(next) {
      trackEvent(ANALYTICS_EVENTS.TABS, {
        fieldId: field.id
      });
      _onChange(next);
    },
    "data-testid": "tabs-".concat(field.id)
  }) : null);
}